module.exports = __webpack_public_path__ + "img/B904.bf8dc0b5.jpg";